interface ExtractedInstructions {
    id: string,
    dataTestId: string
}

export const extractInstructions = (value: any): ExtractedInstructions => {
    let output = {
        id: 'common.no_text',
        dataTestId: ''
    };

    let suffix = '';

    if(Array.isArray(value)) {
        const [ instructionId, additionalIds ] = value;

        output.id = instructionId;

        Object.entries(additionalIds).forEach(([key, value]) => {
            suffix += `_${key}_${value}`;
        });

    } else if (typeof value === 'string') {
        output.id = value;
    } else {
        return output;
    }

    const idPart = output.id.split('.').pop();
    const appliedSuffix = suffix ? suffix : '';

    output.dataTestId = [
        idPart,
        appliedSuffix,
        '_instructional_text'
    ].join('');

    return output;
};
